var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefreshCw05 = function SvgRefreshCw05(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#60646C",
    fillRule: "evenodd",
    d: "M11.764 4.707a5.002 5.002 0 0 0-8.737 2.768.667.667 0 0 1-1.326-.14 6.335 6.335 0 0 1 11.253-3.28l.073-.272a.667.667 0 1 1 1.288.346l-.488 1.82a.667.667 0 0 1-.816.472l-1.822-.488a.667.667 0 1 1 .345-1.288zm1.942 3.225a.667.667 0 0 1 .592.734 6.335 6.335 0 0 1-11.253 3.28l-.072.27a.667.667 0 0 1-1.288-.344l.488-1.822a.667.667 0 0 1 .816-.471l1.822.488a.667.667 0 1 1-.345 1.288l-.23-.062a5.002 5.002 0 0 0 8.736-2.768.667.667 0 0 1 .734-.593",
    clipRule: "evenodd"
  })));
};
export default SvgRefreshCw05;